import { render, staticRenderFns } from "./queryAllCoInvoice.vue?vue&type=template&id=187223bb"
import script from "./queryAllCoInvoice.vue?vue&type=script&lang=js"
export * from "./queryAllCoInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports